import { IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
import Box from "@mui/system/Box";
export const Container = styled(Box, {
    shouldForwardProp: (prop) => prop !== "maxWidth" && prop !== "fullPage" && prop !== "hideHeightForCrop",
})(({ theme, maxWidth, fullPage = false, hideHeightForCrop = false }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: maxWidth,
    width: hideHeightForCrop ? undefined : "100%",
    [theme.breakpoints.down(900)]: {
        top: fullPage ? 0 : undefined,
        left: fullPage ? 0 : undefined,
        transform: fullPage ? "none" : undefined,
        maxWidth: fullPage ? "none" : undefined,
        height: fullPage ? "100%" : undefined,
    },
}));
export const Wrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== "borderRadius" && prop !== "fullPage" && prop !== "noPadding",
})(({ theme, borderRadius = "", fullPage = false, noPadding = false }) => ({
    margin: `0px ${theme.spacing(2)}`,
    backgroundColor: "white",
    borderRadius: borderRadius ? borderRadius : theme.spacing(2),
    padding: noPadding ? 0 : theme.spacing(1.25),
    [theme.breakpoints.down(900)]: {
        borderRadius: fullPage ? 0 : undefined,
        margin: fullPage ? 0 : undefined,
        height: fullPage ? "100%" : undefined,
        padding: fullPage ? 0 : undefined,
        display: fullPage ? "flex" : undefined,
        flexDirection: fullPage ? "column" : undefined,
    },
}));
export const HeaderContainer = styled("div", {
    shouldForwardProp: (prop) => prop !== "headerSpacing" &&
        prop !== "headerBorder" &&
        prop !== "headerPaddingTop" &&
        prop !== "fullPage",
})(({ theme, headerSpacing, headerBorder, headerPaddingTop, fullPage = false }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: headerSpacing
        ? headerSpacing
        : `${headerPaddingTop !== null && headerPaddingTop !== void 0 ? headerPaddingTop : theme.spacing(3)} ${theme.spacing(3)} 0px ${theme.spacing(3)}`,
    borderBottom: headerBorder === true ? "1px solid #eee" : undefined,
    [theme.breakpoints.down(900)]: {
        padding: fullPage
            ? "10px 10px 10px 0px"
            : headerSpacing
                ? 0
                : `${theme.spacing(1)} ${theme.spacing(1)} 0px ${theme.spacing(1)}`,
        borderBottom: fullPage ? "1px solid #eee" : undefined,
        justifyContent: fullPage ? "flex-start" : undefined,
        flexDirection: fullPage ? "row-reverse" : undefined,
        "& > h3": {
            fontSize: fullPage ? "16px" : undefined,
        },
        "& > button": {
            color: fullPage ? "#111A45" : undefined,
        },
    },
}));
export const StyledTypography = styled(Typography, {
    shouldForwardProp: (prop) => prop !== "fullPage" && prop !== "marginCss",
})(({ theme, fullPage = false, marginCss = 0 }) => ({
    marginLeft: marginCss,
    [theme.breakpoints.down(900)]: {
        fontSize: fullPage ? "16px" : undefined,
        marginLeft: fullPage ? "0px" : undefined,
    },
}));
export const StyledIconButton = styled(IconButton, {
    shouldForwardProp: (prop) => prop !== "fullPage", // prevent passing 'fullPage' to DOM
})(({ theme, fullPage = false }) => ({
    [theme.breakpoints.down(900)]: {
        color: fullPage ? "#2a19d2" : undefined,
    },
}));
export const ModalStyle = styled(Modal, {
    shouldForwardProp: (prop) => prop !== "fullPage", // prevent passing 'fullPage' to DOM
})(({ theme, fullPage = false }) => ({
    "& .MuiBox-root:focus-visible": {
        outline: "none",
    },
    [theme.breakpoints.down(900)]: {
        "& .MuiModal-backdrop": {
            display: fullPage ? "none" : undefined,
        },
    },
}));
export const ModalBody = styled("div", {
    shouldForwardProp: (prop) => ![
        "hideScroll",
        "bodyPadding",
        "showheader",
        "fullPage",
        "hideHeightForCrop",
        "maxHeight",
        "footerContent",
    ].includes(prop),
})(({ theme, hideScroll = false, bodyPadding, showheader = false, fullPage = false, hideHeightForCrop = false, maxHeight, footerContent, }) => ({
    maxHeight: maxHeight,
    padding: showheader
        ? bodyPadding
        : !footerContent
            ? `0px ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)}`
            : undefined,
    overflow: hideScroll ? "visible" : "auto",
    [theme.breakpoints.down(900)]: {
        maxHeight: fullPage ? "none" : undefined,
        flexGrow: fullPage ? 1 : undefined,
        padding: fullPage
            ? theme.spacing(1)
            : `0px ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)}`,
    },
    [theme.breakpoints.down(600)]: {
        padding: `0px ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)}`,
    },
}));
export const ModalFooter = styled("div", {
    shouldForwardProp: (prop) => prop !== "fullPage",
})(({ theme, fullPage = false }) => ({
    padding: 10,
    [theme.breakpoints.down(900)]: {
        borderTop: fullPage ? "1px solid #eee" : undefined,
    },
}));
